import { render, staticRenderFns } from "./MateriaPrimaSelecionado.vue?vue&type=template&id=4874531c&scoped=true"
import script from "./MateriaPrimaSelecionado.vue?vue&type=script&lang=js"
export * from "./MateriaPrimaSelecionado.vue?vue&type=script&lang=js"
import style0 from "./MateriaPrimaSelecionado.vue?vue&type=style&index=0&id=4874531c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4874531c",
  null
  
)

export default component.exports